export default __webpack_public_path__ + "static/media/Phone-Splash.e7ec319b.png";